module.exports = __webpack_public_path__ + "img/tj-report-none-1.c5444bdb.png";